<template>
  <div class="container">
    <nav aria-label="breadcrumb" class="noprint" style="margin-top: 15px;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/" name="Inicio">Inicio</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Importação de Lista</li>
      </ol>
    </nav>

    <form class="noprint">
      <p style="margin-left: 15px;">Insira um arquivo .csv para carregar a lista. OBS: O arquivo deve ter a mesma ordem de dados do
        <a download="modelo_coleta_medidas_ballare.csv" href="static/modelo_coleta_medidas_ballare.csv">padrão definido</a>
      </p>
      <div class="row">

        <div class="col-md-8" :class="$store.state.lista_csv.length > 0 ? 'col-md-8' : 'col-md-12'">
          <div class="form-group ">
            <input type="file" class="form-control" id="input-carregar-lista" @change="carregarLista($event)" accept=".csv">
          </div>
        </div>
        <div class="col-md-2 d-flex align-items-start justify-content-end" v-if="$store.state.lista_csv.length > 0">
          <div class="btn btn-dark" @click="Imprimir">IMPRIMIR</div>
        </div>
        <div class="col-md-2 d-flex align-items-start justify-content-end" v-if="$store.state.lista_csv.length > 0">
          <div class="btn btn-dark" @click="exportarLista">EXPORTAR</div>
        </div>
      </div>
    </form>

    <div class="listagem">
      <div class="container">

        <div class="row item" v-for="(item,index) in OrdenarLista($store.state.lista_csv)" :class="[$store.state.index_ativo_lista == item.indice ? 'ativo': '']">

          <div class="col-md-12 cabecalho-item-lista">
            <div class="row">
              <div class="col-md-4">
                <p>Nome:
                  <b>{{item.nome}}</b>
                </p>
              </div>
              <div class="col-md-4">
                <p>Personagem:
                  <b>{{item.personagem}}</b>
                </p>
              </div>
              <div class="col-md-2">
                <p>Turma:
                  <b>{{item.turma}}</b>
                </p>
              </div>
              <div class="col-md-2">
                <p>Idade:
                  <b>{{item.idade}}</b>
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <p>
              <b>Resultado do sistema:</b>
            </p>
            <h5 class="resultado">{{item.resultado.tabela}}</h5>
            <h5 class="resultado">{{item.resultado.molde}}</h5>
          </div>
          <div class="col-md-5">
            <TabelaComparativo v-if="CheckObjetoVazio($store.state.lista_csv[item.indice].molde_manual)" :modelo="item" :molde="item.resultado" />
            <TabelaComparativo v-if="!CheckObjetoVazio($store.state.lista_csv[item.indice].molde_manual)" :modelo="item" :molde="$store.state.lista_csv[item.indice].molde_manual" />
          </div>
          <div class="col-md-4">
            <TrocaMolde :idpai="item.indice" :modelo="item" :verificar="!item.resultado.tem_alerta > 0" @selecionado="MoldeManual" @molde-especial="MoldeEspecial" />
          </div>
          <div class="col-md-8">
            <div class="form-group row">
              <label  class="col-sm-2 col-form-label">Observação</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" style="color:#01c884; font-weight: 500;" :value="item.observacao" @input.lazy="Observacao($event, item.indice)" >
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- tabela de totais -->

    <div class="total" v-show="$store.state.lista_csv.length > 0">
      <div class="row" style="margin-top:40px; margin-bottom:10px;">
        <div class="col-md-10">
          <h5>Resultado Total: </h5>
        </div>
        <div class="col-md-2 d-flex align-items-start justify-content-end" v-if="$store.state.lista_csv.length > 0">
          <div class="btn btn-dark noprint" @click="exportarTotal">EXPORTAR</div>
        </div>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">Molde</th>
            <!-- <th scope="col">Molde</th> -->
            <th class="text-center" scope="col">Numero de Peças</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="resultado in contagem_total">
            <td>{{resultado.molde}}</td>
            <!-- <td>{{resultado.molde}}</td> -->
            <td class="text-center">{{resultado.contagem}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- fim tabela de totais -->

  </div>
</template>
<script>
// import SVGMolde from './partes/SVG'
import TrocaMolde from "./partes/TrocaMolde";
import TabelaComparativo from "./partes/TabelaComparativo";
export default {
  name: "Lista",
  components: {
    TrocaMolde,
    TabelaComparativo
  },
  data() {
    return {
      lista: [],
      contagem_moldes: [],
      total_moldes: [],
      IndexAtivo: null,
      ordenar: false
    };
  },
  computed: {
    contagem_total() {
      let lista = this.$store.state.lista_csv;
      let arrayContagem = [];
      // {nome_molde:'', contagem:null}
      for (var i = 0; i < lista.length; i += 1) {
        if (lista[i].molde_especial) {
          arrayContagem.push({ molde: "MOLDE ESPECIAL" });
        } else if (!this.CheckObjetoVazio(lista[i].molde_manual)) {
          arrayContagem.push({ molde: lista[i].molde_manual.nome_molde });
        } else {
          arrayContagem.push({ molde: lista[i].resultado.nome_molde });
        }
      }
      let contagem = this.$lodash.countBy(arrayContagem, "molde");

      let obj_total = [];
      for (var k in contagem) {
        obj_total.push({ molde: k, contagem: contagem[k] });
      }

      return this.$lodash.orderBy(obj_total, "contagem", "desc");
    }
  },

  methods: {
    getAsText: function(fileToRead) {
      var reader = new FileReader();
      // Read file into memory as UTF-8
      reader.readAsText(fileToRead, "ISO-8859-1");
      // Handle errors load
      reader.onload = this.loadHandler;
      reader.onerror = this.errorHandler;
    },
    loadHandler: function(event) {
      var csv = event.target.result;
      this.processData(csv);
    },
    processData: function(csv) {
      var allTextLines = csv.split(/\r\n|\n/);
      // console.log(allTextLines);
      var lines = [];
      var tarr = [];
      var data;
      for (var i = 0; i < allTextLines.length; i += 1) {
        data = allTextLines[i].split(";");
        tarr = [];
        for (var j = 0; j < data.length; j += 1) {
          // console.log(data[j]);

          tarr.push(data[j]);
        }
        //Ignorar linha do csv vazia
        if (tarr != "") {
          lines.push(tarr);
        }
      }
      var obj = [];
      var obj2 = {};
      for (var i = 1; i < lines.length; i += 1) {
        obj2 = {};

        obj2.molde_manual = {};
        obj2.indice = i - 1;
        obj2.molde_especial = false;
        obj2.personagem = lines[i][0];
        obj2.turma = lines[i][1];
        obj2.nome = lines[i][2];
        obj2.status = lines[i][3];
        obj2.data = lines[i][4];
        obj2.idade = lines[i][5];
        obj2.torax = parseInt(lines[i][6]);
        obj2.cintura = parseInt(lines[i][7]);
        obj2.quadril = parseInt(lines[i][8]);
        obj2.gancho = parseInt(lines[i][9]);
        obj2.saia_meia_coxa = lines[i][10];
        obj2.entre_pernas = lines[i][11];
        obj2.largura_comprimento_braço = lines[i][12];
        obj2.comprimento_tutu = lines[i][15];
        obj2.tipo_figurino = lines[i][16];
        obj2.data_coleta = lines[i][17];
        obj2.observacao = lines[i][18];

        obj.push(obj2);
      }
      this.calcularTabela(obj);
    },
    errorHandler: function(evt) {
      if (evt.target.error.name == "NotReadableError") {
        alert("Canno't read file !");
      }
    },
    carregarLista: function(e) {
      if (window.FileReader) {
        // FileReader are supported.
        this.getAsText(e.target.files[0]);
      } else {
        alert("Utilize um navegador atualizado (google chrome ou firefox).");
      }
      // console.log(e.target.files[0])
      // this.lista = e.target.files[0]
    },
    MoldeEspecial(dados) {
      this.$store.commit("ALTERAR_LISTA_CSV_MOLDE_ESPECIAL", dados);
    },
    CheckObjetoVazio(obj) {
      let retorno = this.$lodash.isEmpty(obj);
      // console.log("RETORNO", retorno);
      return retorno;
    },
    Observacao:function(e, indice){
  
      this.$store.commit('ADD_OBSERVACAO', {"obs":e.target.value, "index":indice})
    },
    MoldeManual(dados) {
      //DADOS: PRIMEIRO ITEM DO ARRAY É O ID DO ITEM DA LISTA E O SEGUNDO ITEM É O OBJ DO MOLDE MANUAL
      // console.log("PAI", dados);
      // let lista = JSON.parse(JSON.stringify(this.$store.state.lista_csv))
      // lista[dados[0]].molde_manual = dados[1]
      // console.log("lista",lista[dados[0]]);
      this.$store.commit("ALTERAR_LISTA_CSV_MOLDE_MANUAL", dados);
    },
    Console(obj) {
      console.log(obj);
    },
    ClasseDiferenca: function(x, y) {
      if (x == y) return "igual";
      if (x > y) return "numMaior";
      if (y > x) return "numMenor";
    },
    calcularTabela: function(lista) {
      let self = this;
      let indexMolde = null;
      let diferenca = null;
      let tabela = JSON.parse(JSON.stringify(TabelaMoldes));
      let contagem_moldes = [];

      for (var i = 0; i < lista.length; i += 1) {
        diferenca = null;
        if (
          lista[i].torax == null ||
          lista[i].torax == "" ||
          lista[i].cintura == null ||
          lista[i].cintura == "" ||
          lista[i].quadril == null ||
          lista[i].quadril == "" ||
          lista[i].gancho == null ||
          lista[i].gancho == ""
        ) {
          lista[i].erro = true;
        } else {
          lista[i].erro = false;
        }

        for (var j = 0; j < tabela.length; j += 1) {
          tabela[j].diferenca_torax = Math.abs(
            tabela[j].torax - lista[i].torax
          );
          tabela[j].diferenca_cintura = Math.abs(
            tabela[j].cintura - lista[i].cintura
          );
          tabela[j].diferenca_quadril = Math.abs(
            tabela[j].quadril - lista[i].quadril
          );
          tabela[j].diferenca_gancho = Math.abs(
            tabela[j].gancho - lista[i].gancho
          );

          tabela[j].soma_diferenca =
            tabela[j].diferenca_torax +
            tabela[j].diferenca_cintura +
            tabela[j].diferenca_quadril +
            tabela[j].diferenca_gancho;

          if (j == 0) {
            indexMolde = j;
            diferenca = tabela[j].soma_diferenca;
          } else {
            if (tabela[j].soma_diferenca < diferenca) {
              (indexMolde = j), (diferenca = tabela[j].soma_diferenca);
            }
            tabela[j].tem_alerta = 0;
            if (tabela[j].diferenca_torax > tabela[j].variacao_minima_largura) {
              tabela[j].obs.var_min_torax = true;
              tabela[j].tem_alerta += 1;
            } else {
              tabela[j].obs.var_min_torax = false;
            }
            if (tabela[j].diferenca_torax > tabela[j].variacao_maxima_largura) {
              tabela[j].obs.var_max_torax = true;
              tabela[j].tem_alerta += 1;
            } else {
              tabela[j].obs.var_max_torax = false;
            }
            if (
              tabela[j].diferenca_cintura > tabela[j].variacao_minima_largura
            ) {
              tabela[j].obs.var_min_cintura = true;
              tabela[j].tem_alerta += 1;
            } else {
              tabela[j].obs.var_min_cintura = false;
            }
            if (
              tabela[j].diferenca_cintura > tabela[j].variacao_maxima_largura
            ) {
              tabela[j].obs.var_max_cintura = true;
              tabela[j].tem_alerta += 1;
            } else {
              tabela[j].obs.var_max_cintura = false;
            }
            if (
              tabela[j].diferenca_quadril > tabela[j].variacao_minima_largura
            ) {
              tabela[j].obs.var_min_quadril = true;
              tabela[j].tem_alerta += 1;
            } else {
              tabela[j].obs.var_min_quadril = false;
            }
            if (
              tabela[j].diferenca_quadril > tabela[j].variacao_maxima_largura
            ) {
              tabela[j].obs.var_max_quadril = true;
              tabela[j].tem_alerta += 1;
            } else {
              tabela[j].obs.var_max_quadril = false;
            }
            if (tabela[j].diferenca_gancho > tabela[j].variacao_minima_gancho) {
              tabela[j].obs.var_min_gancho = true;
              tabela[j].tem_alerta += 1;
            } else {
              tabela[j].obs.var_min_gancho = false;
            }
            if (tabela[j].diferenca_gancho > tabela[j].variacao_maxima_gancho) {
              tabela[j].obs.var_max_gancho = true;
              tabela[j].tem_alerta += 1;
            } else {
              tabela[j].obs.var_max_gancho = false;
            }
          }
        }
        lista[i].index_molde = indexMolde;
        contagem_moldes.push(indexMolde);
        lista[i].resultado = JSON.parse(JSON.stringify(tabela[indexMolde]));
      }
      this.$store.commit("ALTERAR_LISTA_CSV", lista);
      this.lista = lista;
    },
    detalheModelo: function(item, index) {
      this.$store.commit("ITEM_LISTA_ATIVO", index);
      this.$store.commit("ATUALIZAR_TORAX", item.torax);
      this.$store.commit("ATUALIZAR_CINTURA", item.cintura);
      this.$store.commit("ATUALIZAR_QUADRIL", item.quadril);
      this.$store.commit("ATUALIZAR_GANCHO", item.gancho);

      this.$router.push({ name: "Inicio" });
    },
    Imprimir() {
      window.print();
    },
    exportarTotal() {
      var csvContent = "data:text/csv;charset=utf-8,\uFEFF";
      csvContent += "MOLDE;CONTAGEM;\r\n";
      var lista = this.contagem_total;
      for (var i = 0; i < lista.length; i += 1) {
        csvContent += lista[i].molde + ";" + lista[i].contagem + ";" + "\r\n";
      }
      var hoje = new Date();
      var dd = hoje.getDate();
      var mm = hoje.getMonth() + 1; //January is 0!

      var yyyy = hoje.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      hoje = dd + "_" + mm + "_" + yyyy;

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute(
        "download",
        "lista_total_moldes_ballare_" + hoje + ".csv"
      );
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    exportarLista: function() {
      var csvContent =
        "PERSONAGEM;TURMA;NOME;OK;DATA;IDADE;TORAX;CINTURA;QUADRIL;GANCHO;COMP. SAIA;";
      csvContent +=
        "ENTRE PERNAS;L.ARG. E COMP. BRACO;MOLDE DO SISTEMA;MOLDE FINAL;COMP. TUTU;TIPO FIGURINO; DATA COLETA; OBSERVACAO;\r\n";

      var lista = this.$store.state.lista_csv;
      // console.log(lista);
      let molde_especial = "";
      let molde_manual = "";
      let molde_final = "";
      for (var i = 0; i < lista.length; i += 1) {
        if(lista[i].molde_manual.nome_molde){
          molde_final = lista[i].molde_manual.nome_molde
          if(lista[i].molde_especial == true){
            molde_final += ' - ESPECIAL'
          }
        }else{
          molde_final = lista[i].resultado.nome_molde
            if(lista[i].molde_especial == true){
            molde_final += ' - ESPECIAL'
          }
        }
        lista[i].molde_especial == true
          ? (molde_especial = "sim")
          : (molde_especial = "não");
        csvContent +=
          lista[i].personagem +
          ";" +
          lista[i].turma +
          ";" +
          lista[i].nome +
          ";";
        csvContent +=
          lista[i].status +
          ";" +
          lista[i].data +
          ";" +
          lista[i].idade +
          ";" +
          lista[i].torax +
          ";";
        csvContent +=
          lista[i].cintura +
          ";" +
          lista[i].quadril +
          ";" +
          lista[i].gancho +
          ";" +
          lista[i].saia_meia_coxa +
          ";";
        csvContent +=
          lista[i].entre_pernas +
          ";" +
          lista[i].largura_comprimento_braço +
          ";";
        csvContent +=
          lista[i].resultado.nome_molde +
          ";" +
          molde_final +
          ";" +
          lista[i].comprimento_tutu +
          ";" +
          lista[i].tipo_figurino +
          ";" +
          lista[i].data_coleta +
          ";" +
          lista[i].observacao +
          ";" +
          "\r\n";
      }

      var hoje = new Date();
      var dd = hoje.getDate();
      var mm = hoje.getMonth() + 1; //January is 0!

      var yyyy = hoje.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      hoje = dd + "_" + mm + "_" + yyyy;

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8," + "\uFEFF" + encodedUri
      );
      link.setAttribute("download", "lista_moldes_ballare_" + hoje + ".csv");
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    OrdenarLista(lista) {
      // return
      let listaOrdenada;
      listaOrdenada = this.$lodash.orderBy(
        lista,
        "resultado.tem_alerta",
        "desc"
      );
      return listaOrdenada;
    }
  }
};
</script>

      <!-- Add "scoped" attribute to limit CSS to this component only -->
      <style scoped>
@media print {
  .noprint {
    display: none;
  }
}

.item {
  border: 1px solid #e4e4e4;
  margin-bottom: 10px;
  /*cursor: pointer;*/
  padding: 10px;
  page-break-before: auto;
  page-break-after: auto;
  page-break-inside: avoid;
}
.item:hover {
  background-color: #f3f3f3;
}
.resultado {
  color: #e49142;
}
.btn-orange {
  color: #fff;
  background-color: #e59042;
  border-color: #c58951;
}
a {
  color: #e59042;
}

@keyframes detalhe {
  from {
    box-shadow: 0px 0px 10px #077aef;
  }
  to {
    box-shadow: none;
  }
}

.item.ativo {
  /*background-color: #e8e8e8;*/
  animation-name: detalhe;
  animation-duration: 3s;
}
/*    .item.ativo:hover{
      background-color: #e2e2e2;
      }*/

.alerta {
  background-color: #fff3e7;
}
.alerta:hover {
  background-color: #ffe4c9;
}

form {
  margin-top: 50px;
}
.table th,
.table td {
  padding: 0.35rem;
}
.custom-file-label::after {
  content: "Explorador de Arquivos";
}
.cabecalho-item-lista {
  border-bottom: 1px solid #dcd9d9;
  margin-bottom: 15px;
}
.total {
  page-break-before: always;
}
.igual {
  font-weight: 500;
}
.numMaior:before {
  content: "+";
}
.numMaior {
  color: #009fff;
  font-weight: 500;
}
.numMenor:before {
  content: "-";
}
.numMenor {
  color: #c13644;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/lista.vue